// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import UserDataManage from "../../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ThruTimeAccessItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprIcon: cc.Sprite = null;

    @property(cc.Node)
    nodeLock: cc.Node = null;

    private csvInfo: any = null;
    private levelId: string = null;
    private curIdx = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(levelId: string, curIdx: number) {
        this.levelId = levelId;
        this.curIdx = curIdx;
    }

    initUI() {
        let id = this.levelId;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.THRU_TIME_LEVEL, id);
        if (!this.csvInfo) {
            console.error(`未找到数据 THRU_TIME_LEVEL id = ` + id);
            return;
        }

        this.labelName.string = this.csvInfo.name;

        this.refreshLockState();
        this.showIcon();
    }

    refreshLockState() {
        let id = this.levelId;
        let thruTimeDataManage = UserDataManage.instance.thruTimeDataManage;
        let thruTimeData = thruTimeDataManage.thruTimeData;

        this.nodeLock.active = thruTimeData.lists.get(id) ? false : true;
    }

    showIcon() {
        let path = 'res/level/items/' + this.csvInfo.icon;
        this.sprIcon.node.active = false;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.thruTimeAccess).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprIcon.node.active = true;
                    this.sprIcon.spriteFrame = imgs;
                }
            }
        );
    }

    onClickEnter() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if (this.nodeLock.active) {
            let thruTimeDataManage = UserDataManage.instance.thruTimeDataManage;
            utilsModel.loadAndShowVideoAdTrans(()=>{
                thruTimeDataManage.openNewLevel(this.levelId);
                this.refreshLockState();
                this.enterLevel();
            },()=>{
    
            },null,"观看广告打开关卡")
        } else {
            this.enterLevel();
        }
    }

    enterLevel() {
        O1HD.emit(MessageEventKind.EventName.ENTER_THRU_TIME_LEVEL, this.curIdx);
    }
    
    // update (dt) {}
}
